import styled from 'styled-components';
import React from 'react';
import { RewindButtonEds } from '../buttons/RewindButtonEds';
import { useGlobalMediaStore } from '~/ui/video-player/GlobalMediaProvider';

const Button = styled(RewindButtonEds)`
  position: fixed;
  bottom: 8px;
  left: 8px;
  z-index: 101 !important;
`;

export const TenSecsBack = () => {
  const globalMedia = useGlobalMediaStore();
  const globalPlayer = globalMedia?.player;

  if (!globalPlayer) return null;

  return (
    <Button
      onClick={() => {
        if (globalPlayer) {
          try {
            const newTime = globalPlayer.currentTime() - 10;
            globalPlayer.currentTime(newTime > 0 ? newTime : 0);
          } catch (error) {
            // Silently ignore player operation errors
          }
        }
      }}
    />
  );
};
